import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import baltimore__asset from "@/assets/restore/locations/baltimore.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Baltimore",
    address: "4000 East Pratt St, 8th Floor",
    img: baltimore__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=4000+East+Pratt+St+Baltimore+MD",
    to: "/locations/maryland/baltimore/",
  },
];

export const Route = createFileRoute("/locations/maryland/")({
  head: () => ({
    meta: [
      { title: "Maryland Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Maryland. Book a free personal hair loss consultation at our Baltimore location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Maryland Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Baltimore, Maryland and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/maryland/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/maryland/" }],
  }),
  component: () => <StateLocationsHub stateName="Maryland" cities={cities} />,
});